/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import NotificationsIcon from "@mui/icons-material/Notifications";
import {
  Badge,
  IconButton,
  Popover,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import axios from "axios";
// import { Tooltip } from "@mui/material";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  // Fetch notifications from backend
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          "https://codefort.onrender.com/api/notifications",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setNotifications(response.data);
        setUnreadCount(
          response.data.filter((n) => n.status === "unread").length
        );
      } catch (error) {}
    };
    fetchNotifications();
  }, []);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const markAsRead = async (id) => {
    try {
      const token = localStorage.getItem("token"); // Certifique-se de passar o token se necessário
      await axios.patch(
        `https://codefort.onrender.com/api/notifications/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setNotifications((prev) =>
        prev.map((n) => (n._id === id ? { ...n, status: "read" } : n))
      );
      setUnreadCount((prev) => prev - 1);
    } catch (error) {}
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        color="inherit"
        sx={{
          padding: "8px",
          fontSize: "1.5rem", // Ajuste o tamanho do ícone aqui
          "& .MuiBadge-badge": {
            backgroundColor: unreadCount > 0 ? "red" : "gray", // Cor para notificações
            color: "white",
          },
        }}
      >
        <Badge badgeContent={unreadCount} color="secondary">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <List>
          {notifications.length === 0 ? (
            <Typography
              sx={{ padding: 2, textAlign: "center" }}
              variant="body2"
            >
              Nenhuma notificação
            </Typography>
          ) : (
            notifications.map((n) => (
              <ListItem
                key={n._id}
                button
                onClick={() => markAsRead(n._id)}
                sx={{
                  backgroundColor:
                    n.status === "unread"
                      ? theme.palette.mode === "dark"
                        ? "rgba(255, 255, 255, 0.1)"
                        : "rgba(0, 0, 0, 0.05)"
                      : "transparent",
                  color:
                    n.status === "unread"
                      ? theme.palette.text.primary
                      : theme.palette.text.secondary,
                  "&:hover": {
                    backgroundColor:
                      theme.palette.mode === "dark"
                        ? "rgba(255, 255, 255, 0.2)"
                        : "rgba(0, 0, 0, 0.1)",
                  },
                  borderBottom: `1px solid ${
                    theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.1)"
                      : "rgba(0, 0, 0, 0.1)"
                  }`,
                  cursor: "pointer",
                }}
                title={`${n.title}: ${n.message}`} // Exibe o conteúdo completo
              >
                <ListItemText
                  primary={n.title}
                  secondary={n.message}
                  primaryTypographyProps={{
                    sx: {
                      fontWeight: n.status === "unread" ? "bold" : "normal",
                    },
                  }}
                />
              </ListItem>
            ))
          )}
        </List>
      </Popover>
    </>
  );
};

export default Notifications;
